export const PRODUCT_SET_SELECTED_PRODUCT_UNAVAILABLE =
  'SELECTED_PRODUCT_UNAVAILABLE';
export const PRODUCT_SET_INIT = 'INIT';
export const PRODUCT_SET_OK = 'OK';
export const PRODUCT_SET_SELECTED_PRODUCT_PRICE_CHANGED =
  'SELECTED_PRODUCT_PRICE_CHANGED';
export const PRODUCT_SET_FAILED_UNAVAILABLE = 'FAILED_UNAVAILABLE';
export const productSetStatuses = [
  PRODUCT_SET_INIT,
  PRODUCT_SET_OK,
  PRODUCT_SET_SELECTED_PRODUCT_UNAVAILABLE,
  PRODUCT_SET_SELECTED_PRODUCT_PRICE_CHANGED,
  PRODUCT_SET_FAILED_UNAVAILABLE,
] as const;
